import axiosInstance from "../config/axios";
import router from "../router";
import { defineStore } from "pinia";
import { useShopStore } from "@/store/shop";
import { v4 as uuidv4 } from "uuid";

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            calendarRange: [],
            uuid: null,
        };
    },
    actions: {
        setUuid() {
            this.uuid = uuidv4();
        },
        createUserPageLog() {
            const shopStore = useShopStore();
            let shopId = null;

            if (shopStore.selectedShop?.id !== undefined) {
                shopId = shopStore.selectedShop.id;
            } else if (shopStore.selectedShopId !== null) {
                shopId = shopStore.selectedShopId;
            }

            axiosInstance.post("/v1/pageLogging", {
                "identification_id": shopId,
                "page": router.currentRoute.value.path === "/" ? "Home" : router.currentRoute.value.name,
                "uuid": this.uuid
            });
        },
    },
    getters: {
        dateFrom(state) {
            return state.calendarRange[0]
                ? `${state.calendarRange[0].getFullYear()}-${
                      state.calendarRange[0].getMonth() + 1
                  }-${state.calendarRange[0].getDate()}`
                : null;
        },
        dateTo(state) {
            return state.calendarRange[1]
                ? `${state.calendarRange[1].getFullYear()}-${
                      state.calendarRange[1].getMonth() + 1
                  }-${state.calendarRange[1].getDate()}`
                : null;
        },
        dateFromPre(state) {
            if (state.calendarRange[0] && state.calendarRange[1]) {
                let daysDiff = Math.ceil(
                    Math.abs(state.calendarRange[1] - state.calendarRange[0]) / (24 * 60 * 60 * 1000)
                );

                let date = new Date(state.calendarRange[0].valueOf());
                date.setDate(date.getDate() - (daysDiff + 1));

                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            }
        },
        dateToPre(state) {
            if (state.calendarRange[0]) {
                let date = new Date(state.calendarRange[0].valueOf());
                date.setDate(date.getDate() - 1);

                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            }
        },
        diffDays(state) {
            if (state.calendarRange[0] && state.calendarRange[1]) {
                const oneDay = 24 * 60 * 60 * 1000;
                const diffTime = Math.abs(state.calendarRange[1] - state.calendarRange[0]);
                const diffRound = Math.round(diffTime / oneDay);

                return diffRound + 1;
            }
        },
    },
});
